import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Button } from 'shared/mui/Buttons';
import { CardActionsButtons, CardHeader } from 'shared/mui/Card';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { Dialog } from 'shared/mui/Dialogs';
import { CloseIconButton } from 'shared/mui/IconButtons';

type MerchantsShowNotificationsSendNotificationDialogProps = {
  open: boolean;
  onClose: VoidFunction;
};

export const MerchantsShowNotificationsSendNotificationDialog: React.FC<
  MerchantsShowNotificationsSendNotificationDialogProps
> = ({ open, onClose }) => {
  const translate = useTypedTranslate();

  return (
    <Dialog onClose={onClose} open={open} width="640px">
      <CardHeader
        appendActions={<CloseIconButton key="close-button" onClose={onClose} />}
        title={translate('app.merchantsShowNotifications.sendTestMessage')}
        titleSize="smallBold"
      />
      <CardContent>{translate('app.merchantsShowNotifications.testMessageSent')}</CardContent>
      <CardActionsButtons
        rightActionsSlot={
          <Button label={translate('app.buttons.close')} onClick={onClose} variant="outlined" />
        }
      />
    </Dialog>
  );
};
